// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4k-7";
export var adjustableWidthBorderHeld = "_4k-8";
export var arrow = "_4k-3";
export var arrowButton = "_4k-4";
export var headerCell = "_4k-0";
export var help = "_4k-2";
export var icon = "_4k-1";
export var iconWrapper = "_4k-6";
export var noBorder = "_4k-b";
export var nonAdjustableWidthBorder = "_4k-9";
export var nonAdjustableWidthBorderHeld = "_4k-a";
export var textButton = "_4k-5";